import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Stepper from "../../../components/admin/home/Stepper";
import Footer from "../../../components/layout/footer";
import Header from "../../../components/layout/header";
import { resolveCompanyId } from "../../../utils/resolveCompanyId";

const AdminHome = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    resolveCompanyId().then((companyId) => {
      if (companyId) {
        navigate("/admin/dashboard", { replace: true });
      } else {
        setChecking(false);
      }
    });
  }, [navigate]);

  if (checking) return null;

  return (
    <>
      <Header Logout={true} />
      <Stepper />
      <Footer />
    </>
  );
};
export default AdminHome;
